"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import { X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import Chat from "~/components/icons/chat-eon";
import { useOutsideClick } from "~/hooks/use-outside-click";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { ContactImage } from "../contact/contact-eon";
export default function StickyContact(t0) {
  const $ = _c(26);
  const {
    job
  } = t0;
  const t = useLanguage();
  const [showDetails, setShowDetails] = useState(false);
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowDetails(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const outsideClickRef = useOutsideClick(t1);
  const recruiterData = job.data.recruiterData;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const element = containerRef.current;
      if (!element) {
        return;
      }
      const handleTouchMove = _temp;
      element.addEventListener("touchmove", handleTouchMove, {
        passive: false
      });
      return () => {
        element.removeEventListener("touchmove", handleTouchMove);
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!recruiterData) {
    return null;
  }
  const t4 = showDetails ? "w-82 bg-primary sm:w-96 lg:w-[420px]" : "h-12 w-12 bg-secondary md:h-20 md:w-20";
  let t5;
  if ($[3] !== t4) {
    t5 = cn("relative rounded-l-md shadow-[0_4px_8px_0_rgba(0,0,0,0.15)] transition-all duration-500", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = t.jobad_stickyContact_title;
  const t7 = showDetails && "hidden";
  let t8;
  if ($[5] !== t7) {
    t8 = cn("flex h-full w-full items-center justify-center text-3xl md:text-4xl", t7);
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setShowDetails(true);
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Chat className="h-8 w-8 md:h-14 md:w-14" />;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== showDetails || $[10] !== t.jobad_stickyContact_title || $[11] !== t8) {
    t11 = <button aria-expanded={showDetails} aria-label={t6} className={t8} onClick={t9} type="button">{t10}</button>;
    $[9] = showDetails;
    $[10] = t.jobad_stickyContact_title;
    $[11] = t8;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== job || $[14] !== recruiterData || $[15] !== showDetails || $[16] !== t.jobad_contactHL || $[17] !== t.jobad_stickyContact_close_title) {
    t12 = showDetails && <><button aria-label={t.jobad_stickyContact_close_title} className="absolute top-2 right-2 flex text-3xl" onClick={() => setShowDetails(false)} type="button"><X className="size-10" /></button><div className="grid p-6"><div className="mb-4 w-full"><h2 className="my-2 w-3/4 font-medium text-2xl md:text-3xl lg:text-4xl" data-source="lc">{t.jobad_contactHL}</h2><p data-source="job">{recruiterData.recruiter_text}</p></div><ContactImage job={job} sticky={true} /></div></>;
    $[13] = job;
    $[14] = recruiterData;
    $[15] = showDetails;
    $[16] = t.jobad_contactHL;
    $[17] = t.jobad_stickyContact_close_title;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12 || $[21] !== t5) {
    t13 = <div className={t5} ref={containerRef}>{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t5;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== outsideClickRef || $[24] !== t13) {
    t14 = <div className="fixed right-0 bottom-24 z-50 text-white print:hidden" ref={outsideClickRef}>{t13}</div>;
    $[23] = outsideClickRef;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp(e) {
  e.preventDefault();
}